import ReactDOM from "react-dom";
import { ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { backdropStyle, modalStyle } from "DialogProviderShare";
import AppSimpleBar from "components/AppSimpleBar";

export interface DialogProviderCommonInfoProps {
  children: ReactNode;
  onClose: (v: any) => void;
  title?: string;
  // active?: boolean;
}

export function DialogProviderCommonInfoPortal({ children, onClose, title }: DialogProviderCommonInfoProps) {
  const handleEsc = useCallback((event: any) => {
    if (event.key === "Escape") {
      onClose(null);
    }
  }, [onClose]);

  useEffect(() => {
    // Add listener when the modal mounts
    window.addEventListener("keydown", handleEsc);

    // Clean up listener when the modal unmounts
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [handleEsc]);

  return ReactDOM.createPortal(
    <div style={backdropStyle}>
      <div style={modalStyle}>
        {title && <h5>{title}</h5>}
        

        <AppSimpleBar style={{ maxHeight: "calc(100vh - 200px)", overflowX: "hidden", overflowY: "auto" }}>
          {/* Renders whatever component you pass inside */}
          {children}
        </AppSimpleBar>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, padding: '10px', borderTop: "dashed 1px var(--m2-line-divider-color)" }}>
          <button className="btn btn-warning" onClick={() => onClose(null)}>ปิด</button>
        </div>
      </div>
    </div>,
    document.body
  );
}